import { Box, Button, Collapse, TableCell, TableRow } from '@mui/material';
import React, { useState } from 'react';

import { FormulaActivityAttributes } from '../../../services/types/apiType';
import { columns } from '../utils';

interface FormulaActivityRowProps {
  data: FormulaActivityAttributes;
  onEditRow: () => void;
  onDeleteRow: () => void;
}
const FormulaActivityRow: React.FC<FormulaActivityRowProps> = ({ data, onEditRow, onDeleteRow }) => {
  const [isExpand, setExpand] = useState(false);

  return (
    <>
      <TableRow
        sx={{ cursor: 'pointer', '& > *': { borderBottom: 'unset !important' } }}
        onClick={() => setExpand(!isExpand)}
        hover
        role="checkbox"
        tabIndex={-1}
        key={data.id}
      >
        {columns.map((column) => (
          <TableCell sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }} key={column.id} align={column.align}>
            {`${(column.format ? column.format(data[column.id]) : data[column.id]) || ''}`}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell sx={{ p: 0 }} colSpan={10}>
          <Collapse in={isExpand} timeout="auto" unmountOnExit>
            <Box textAlign="right" p={1}>
              <Button variant="contained" sx={{ mr: 2 }} onClick={onEditRow}>
                Chỉnh sửa
              </Button>
              <Button color="error" variant="contained" sx={{ mr: 2 }} onClick={onDeleteRow}>
                Xoá
              </Button>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default FormulaActivityRow;
